import classnames from 'classnames';
import React from 'react';

import { Button } from '../../spaces-bundle/components/Button/Button';
import { ProButton } from '@wetransfer/transfer/component/ProButton/ProButton';

interface CTA {
  text: string;
  href: string;
  onClick?(event?: React.MouseEvent): void;
}

export interface Props {
  cta?: CTA;
  isProPanel?: boolean;
  colorScheme: 'Light' | 'Dark' | 'Transparent' | 'Medium';
  isClassicVariant?: boolean;
}

export const PricingPanelButton: React.FC<Props> = ({
  cta,
  isProPanel,
  colorScheme,
  isClassicVariant = false,
}) => {
  const colorSchemeIsDark = colorScheme === 'Dark';
  const colorSchemeIsLight = colorScheme === 'Light';
  const colorSchemeIsTransparent = colorScheme === 'Transparent';
  const colorSchemeIsMedium = colorScheme === 'Medium';

  if ((isProPanel && isClassicVariant) || colorSchemeIsLight) {
    return (
      <ProButton
        text={cta.text}
        href={cta.href}
        // eslint-disable-next-line react/jsx-no-bind
        onClick={cta.onClick}
      />
    );
  }

  if (isClassicVariant) {
    return (
      <Button
        as="a"
        rounded
        variant="secondary"
        href={cta.href}
        onClick={cta.onClick}
      >
        {cta.text}
      </Button>
    );
  }

  return (
    <Button
      as="a"
      className={classnames('PricingPanel__button', {
        'PricingPanel__button--light': colorSchemeIsDark,
        'PricingPanel__button--dark': colorSchemeIsLight,
        'PricingPanel__button--transparent': colorSchemeIsTransparent,
        'PricingPanel__button--medium': colorSchemeIsMedium,
      })}
      href={cta.href}
      onClick={cta.onClick}
    >
      {cta.text}
    </Button>
  );
};

export default PricingPanelButton;
